import { render, staticRenderFns } from "./PersonalInformation2.vue?vue&type=template&id=2541eb7d"
import script from "./PersonalInformation2.vue?vue&type=script&lang=js"
export * from "./PersonalInformation2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports